export default __webpack_public_path__ + "static/media/Yurt5.1f64f7fd.jpg";